export enum MatchmakingCardCategory {
    Bots,
    Casual,
    Ranked,
}
